import { render } from "./MachineLearning.vue?vue&type=template&id=4b7d83af"
import script from "./MachineLearning.vue?vue&type=script&lang=js"
export * from "./MachineLearning.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__